import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateTaxCodeForm from '../../forms/CreateOrUpdateTaxCodeForm'

interface CreateTaxCodeModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateTaxCodeModal: React.FC<CreateTaxCodeModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Tax Code" width="sm" loading={loading}>
    <CreateOrUpdateTaxCodeForm loading={loading} error={error} />
  </AppModal>
)

export default CreateTaxCodeModal
